module.exports = __webpack_public_path__ + "img/54.1c9a2636.jpg";